export default __webpack_public_path__ + "static/media/Wednesday_09.010eab1d.png";